export { default } from './ConfirmProvider';
export * from './ConfirmProvider';

export { default as NewConfirm } from './NewConfirmProvider';
export * from './NewConfirmProvider';
